// Lista dos [?] do SOAP (Regra 3 — incerteza visível). Cada item mostra o campo e
// uma JANELA DE CONTEXTO ao redor do marcador — NÃO "a frase incerta", porque o
// texto não delimita seu início (ver lib/marcadores.ts). Sem coluna de timestamp:
// o áudio é apagado após o STT (Regra 6) e não há timestamps na API.

import type { CSSProperties } from 'react';

import { trechosIncertos } from '../../lib/marcadores';
import { cor, fonte } from '../../styles/tokens';
import type { Soap } from '../../api/types';

const item: CSSProperties = {
  display: 'flex',
  gap: 9,
  alignItems: 'baseline',
  borderLeft: `3px solid ${cor.ambarBorda}`,
  padding: '4px 0 4px 9px',
  background: cor.ambarBg,
};

export function TrechosIncertos({ soap }: { soap: Soap }): JSX.Element {
  const itens = trechosIncertos(soap);
  return (
    <div style={{ borderTop: `1px solid rgba(29,31,32,.14)`, paddingTop: 14 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          marginBottom: 8,
        }}
      >
        <span
          style={{ fontFamily: fonte.mono, fontSize: 10, letterSpacing: '.14em', color: cor.muted }}
        >
          TRECHOS INCERTOS
        </span>
        <span style={{ fontFamily: fonte.mono, fontSize: 15, color: cor.ambarBorda }}>
          {itens.length}
        </span>
      </div>

      {itens.length === 0 ? (
        <div style={{ fontSize: 12.5, color: cor.muted, lineHeight: 1.5 }}>
          Nenhum trecho marcado como incerto.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {itens.map((t, i) => (
            <div key={i} style={item}>
              <span style={{ fontFamily: fonte.mono, fontSize: 10.5, color: cor.ambarBorda }}>
                {t.campo}
              </span>
              <span style={{ fontFamily: fonte.serif, fontSize: 13, color: cor.texto }}>
                {t.contexto}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
